import { render, staticRenderFns } from "./prontuario_paciente.vue?vue&type=template&id=64c9e888&scoped=true&"
import script from "./prontuario_paciente.vue?vue&type=script&lang=js&"
export * from "./prontuario_paciente.vue?vue&type=script&lang=js&"
import style0 from "./prontuario_paciente.vue?vue&type=style&index=0&id=64c9e888&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c9e888",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VCardText,VDataTable,VDialog,VIcon,VProgressLinear,VSpacer,VTextField,VToolbar})
